import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import NewsCard from "@/components/feature/NewsCard";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { newsArticles } from "@/mocks/news";

const filters = ["全部", "资讯", "花絮", "评论"];

export default function News() {
  const [category, setCategory] = useState("全部");

  useDocumentMeta({
    title: "出轨的味道资讯专题 - 最新新闻、花絮与评论",
    description: "出轨的味道资讯专题页，汇集该剧最新动态、幕后花絮、深度评论与相关推荐，掌握“出轨的味道”影视内容的一手资讯。",
    keywords: "出轨的味道,影视资讯,剧情评论,幕后花絮,电视剧新闻,影视专题",
  });

  const list = useMemo(
    () => (category === "全部" ? newsArticles : newsArticles.filter((item) => item.category === category)),
    [category]
  );

  return (
    <AppLayout>
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-8 md:py-10">
        <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-foreground-500">
          <Link to="/" className="transition-colors hover:text-accent-700 cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-800">资讯专题</span>
        </nav>

        <header className="mt-5 mb-6">
          <p className="font-label text-[11px] tracking-[0.3em] text-accent-600">NEWS & FEATURES</p>
          <h1 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">资讯专题</h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
            围绕“出轨的味道”系列及相关影视主题，为你整理最新资讯、幕后花絮与深度评论内容，帮助你更全面地了解剧情与创作背景。
          </p>
        </header>

        <div className="mb-6 flex flex-wrap items-center gap-2">
          {filters.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setCategory(item)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition-colors cursor-pointer ${
                category === item
                  ? "bg-primary-600 text-background-50"
                  : "bg-background-200/70 text-foreground-700 hover:bg-background-300/70"
              }`}
            >
              {item}
            </button>
          ))}
          <span className="ml-auto text-xs text-foreground-500">共 {list.length} 篇</span>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <NewsCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </AppLayout>
  );
}